/**
 * Special-offer slider — scrolls a horizontal product list by one card per
 * arrow-press. Disabled state on each arrow tracks whether more content
 * exists in that direction.
 *
 * Markup contract:
 *   [data-special-offer]
 *     [data-special-offer-track]   — horizontally scrollable list
 *     [data-special-offer-prev]    — scroll back one card
 *     [data-special-offer-next]    — scroll forward one card
 */
(() => {
  const init = (root) => {
    const track = root.querySelector('[data-special-offer-track]');
    const prev = root.querySelector('[data-special-offer-prev]');
    const next = root.querySelector('[data-special-offer-next]');
    if (!track) return;

    const step = () => {
      const first = track.children[0];
      if (!first) return 0;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    };

    const updateNav = () => {
      if (!prev || !next) return;
      const max = track.scrollWidth - track.clientWidth - 1;
      prev.toggleAttribute('disabled', track.scrollLeft <= 0);
      next.toggleAttribute('disabled', track.scrollLeft >= max);
    };

    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();

    // Optimistically toggle the heart icon. A real wishlist sync would be wired
    // through `data-wishlist-toggle` in the cart/wishlist drawer; this just
    // gives instant visual feedback on click.
    root.querySelectorAll('.product-card__heart').forEach((btn) => {
      btn.addEventListener('click', () => {
        const pressed = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', String(!pressed));
      });
    });
  };

  const ready = () => document.querySelectorAll('[data-special-offer]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
})();
